module.exports = __webpack_public_path__ + "static/media/img_overpaper4@3x.25d6d859.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_overpaper4@3x.png
// module id = 970
// module chunks = 0